import { createFileRoute } from '@tanstack/react-router'

import { GeneralTermsDocumentationPage } from '../../../../components/pages/backoffice/platform/platform-documentation/general-terms-documentation-page.tsx'

export const Route = createFileRoute('/bo/documentation/general-terms')({
  component: () => <GeneralTermsDocumentationPage />,
})
